import IconChevronDown from '@apollo/icons/default/IconChevronDown.svg';
import { Button, ButtonProps, forwardRef } from '@apollo/orbit';
import React from 'react';

export const FilterButton = forwardRef<ButtonProps, 'button' | 'a'>(
  ({ leftIcon, className, children, size = 'sm', ...other }, ref) => (
    <Button
      size={size}
      className={className}
      leftIcon={leftIcon}
      rightIcon={<IconChevronDown />}
      ref={ref}
      {...other}
    >
      {children}
    </Button>
  ),
);
